const paragraph = document.querySelector('.section__header--paragraph--js')
paragraph.innerHTML = 'Ten tekst widzisz dzięki JS.'
paragraph.style.color = ('red')

export {paragraph};